/*
 *  Copyright (c) Qwoach LLC 2026. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 */

export const BookStatusEnum = Object.freeze({
	DRAFT: "DRAFT",
	COMPLETED: "COMPLETED",
})

export const bookStatusOptions = Object.freeze([
	{value: BookStatusEnum.DRAFT, label: "In progress"},
	{value: BookStatusEnum.COMPLETED, label: "Completed"},
])

export function titleForBookStatus(bookStatus) {
	let statusOption = bookStatusOptions.find(option => option.value === bookStatus)
	return statusOption?.label || bookStatusOptions[0].label
}
